module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "uk-child-width-expand@m",
    attrs: {
      "uk-grid": ""
    }
  }, [_c('div', [_c('div', {
    staticClass: "uk-card uk-card-default uk-card-body"
  }, [_c('h3', {
    staticClass: "uk-card-title"
  }, [_vm._v("Kartoteka pacjenta")]), _vm._v(" "), _c('table', {
    staticClass: "uk-table uk-table-small uk-table-striped"
  }, [_c('tr', [_vm._m(0), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.Nazwisko))])])]), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.Imie))])])]), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.Imie2))])])]), _vm._v(" "), _c('tr', [_vm._m(3), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.PESEL))])])]), _vm._v(" "), _c('tr', [_vm._m(4), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.DataUr))])])]), _vm._v(" "), _c('tr', [_vm._m(5), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.MiejsceUr))])])]), _vm._v(" "), _c('tr', [_vm._m(6), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.TelKom))])])]), _vm._v(" "), _c('tr', [_vm._m(7), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.Tel))])])]), _vm._v(" "), _c('tr', [_vm._m(8), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.Email))])])])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "uk-button uk-button-default uk-button-small uk-margin-small-right uk-margin-small-top",
    attrs: {
      "uk-toggle": "target: #pass-change-modal",
      "type": "button"
    }
  }, [_vm._v("Zmień hasło")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-default uk-button-small uk-margin-small-right uk-margin-small-top",
    attrs: {
      "uk-toggle": "target: #email-patient-reminder-modal",
      "type": "button"
    }
  }, [_vm._v("Edytuj Email")]), _vm._v(" "), _c('router-link', {
    staticClass: "uk-button uk-button-default uk-button-small uk-margin-small-top",
    attrs: {
      "to": {
        name: 'contact',
        params: {}
      }
    }
  }, [_vm._v("Chcę poprawić swoje dane")])], 1), _vm._v(" "), _c('h3', {
    staticClass: "uk-card-title"
  }, [_vm._v("Adres zameldowania")]), _vm._v(" "), _c('table', {
    staticClass: "uk-table uk-table-small uk-table-striped"
  }, [_c('tr', [_vm._m(9), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.KodPocztowy) + " ")]), _c('span', [_vm._v(_vm._s(_vm.Pacjent.Poczta))])])]), _vm._v(" "), _c('tr', [_vm._m(10), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.Miejscowosc))])])]), _vm._v(" "), _c('tr', [_vm._m(11), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.UlicaAlejaPlac) + " ")]), _c('span', [_vm._v(_vm._s(_vm.Pacjent.Ulica))])])]), _vm._v(" "), _c('tr', [_vm._m(12), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.NrDomu))])])]), _vm._v(" "), _c('tr', [_vm._m(13), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.NrMieszkania))])])]), _vm._v(" "), _c('tr', [_vm._m(14), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.Kraj))])])])]), _vm._v(" "), _c('h3', {
    staticClass: "uk-card-title"
  }, [_vm._v("Adres korespondencyjny")]), _vm._v(" "), _c('table', {
    staticClass: "uk-table uk-table-small uk-table-striped"
  }, [_c('tr', [_vm._m(15), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.KodPocztowy2) + " ")]), _c('span', [_vm._v(_vm._s(_vm.Pacjent.Poczta2))])])]), _vm._v(" "), _c('tr', [_vm._m(16), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.Miejscowosc2))])])]), _vm._v(" "), _c('tr', [_vm._m(17), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.UlicaAlejaPlac2) + " ")]), _c('span', [_vm._v(_vm._s(_vm.Pacjent.Ulica2))])])]), _vm._v(" "), _c('tr', [_vm._m(18), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.NrDomu2))])])]), _vm._v(" "), _c('tr', [_vm._m(19), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.Pacjent.NrMieszkania2))])])])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "uk-card uk-card-default uk-card-body"
  }, [_c('h3', {
    staticClass: "uk-card-title"
  }, [_vm._v("Dodatkowe uprawnienia")]), _vm._v(" "), _c('table', {
    staticClass: "uk-table uk-table-small uk-table-striped"
  }, _vm._l((_vm.NFZElements), function(element) {
    return _c('tr', [_c('td', [_c('strong', [_vm._v(_vm._s(element.Opis))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(element.Wartosc))])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "email-patient-reminder-modal",
      "uk-modal": ""
    }
  }, [_c('div', {
    staticClass: "uk-modal-dialog uk-modal-body"
  }, [_c('h2', {
    staticClass: "uk-modal-title"
  }, [_vm._v("Zmiana adresu email")]), _vm._v(" "), _vm._m(20), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEmail),
      expression: "newEmail"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "email",
      "placeholder": "Twój aktualny email"
    },
    domProps: {
      "value": (_vm.newEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newEmail = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-flex uk-flex-right"
  }, [_c('button', {
    staticClass: "uk-button uk-button-default uk-modal-close uk-margin-small-left",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Anuluj")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-secondary uk-margin-small-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setEmail
    }
  }, [_vm._v("Zapisz")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "pass-change-modal",
      "uk-modal": ""
    }
  }, [_c('div', {
    staticClass: "uk-modal-dialog uk-modal-body"
  }, [_c('h2', {
    staticClass: "uk-modal-title"
  }, [_vm._v("Zmiana hasła")]), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.passNew),
      expression: "credentials.passNew"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "password",
      "placeholder": "Nowe hasło"
    },
    domProps: {
      "value": (_vm.credentials.passNew)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "passNew", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.passNew_2),
      expression: "credentials.passNew_2"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "password",
      "placeholder": "Powtórz nowe hasło"
    },
    domProps: {
      "value": (_vm.credentials.passNew_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "passNew_2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "uk-flex uk-flex-right"
  }, [_c('button', {
    staticClass: "uk-button uk-button-default uk-modal-close uk-margin-small-left",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Anuluj")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-secondary uk-margin-small-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setPass
    }
  }, [_vm._v("Zapisz")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Nazwisko")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Imię")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Drugie imię")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("PESEL")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Data urodzenia")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Miejsce urodzenia")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Telefon kom.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Telefon dom")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Kod. Poczta")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Miejscowość")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Ulica")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Numer domu")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Numer lokalu")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Kraj")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Kod. Poczta")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Miejscowość")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Ulica")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Numer domu")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Numer lokalu")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-alert-danger",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "error_empty_email",
      "uk-alert": ""
    }
  }, [_c('h3', [_vm._v("Wystąpił błąd")]), _vm._v(" "), _c('p', [_vm._v("Wprowadź poprawny adres email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-alert-danger",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "error_box_mismatch",
      "uk-alert": ""
    }
  }, [_c('h3', [_vm._v("Wystąpił błąd")]), _vm._v(" "), _c('p', [_vm._v("Podane hasła nie są takie same.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-alert-danger",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "error_box_characters",
      "uk-alert": ""
    }
  }, [_c('h3', [_vm._v("Wystąpił błąd")]), _vm._v(" "), _c('p', [_vm._v("Hasło powinno zawierać minimum 8 znaków, co najmniej 1 dużą litere, małą litere, cyfre oraz znak specjalny !@#$%^&*()+-={}|:<>?;.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-alert-danger",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "error_box_empty",
      "uk-alert": ""
    }
  }, [_c('h3', [_vm._v("Wystąpił błąd")]), _vm._v(" "), _c('p', [_vm._v("Proszę wprowadzić hasło.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ef0cfb8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Data.vue
// module id = 237
// module chunks = 1